import { render, staticRenderFns } from "./ReguaEnrollmentBadge.vue?vue&type=template&id=dc6525a0&"
import script from "./ReguaEnrollmentBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReguaEnrollmentBadge.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports